export default __webpack_public_path__ + "static/media/011.0be95538.webp";